"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * DevourPlay OpenAPI (Swagger) Documentation
 * This is the API documentation generated from the swagger comments in the backend. These correspond directly to the client library.
 *
 * The version of the OpenAPI document: N/A
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.InlineObject7ToJSON = exports.InlineObject7FromJSONTyped = exports.InlineObject7FromJSON = void 0;
function InlineObject7FromJSON(json) {
    return InlineObject7FromJSONTyped(json, false);
}
exports.InlineObject7FromJSON = InlineObject7FromJSON;
function InlineObject7FromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'code': json['code'],
    };
}
exports.InlineObject7FromJSONTyped = InlineObject7FromJSONTyped;
function InlineObject7ToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'code': value.code,
    };
}
exports.InlineObject7ToJSON = InlineObject7ToJSON;
